// Revivo — default brand.
//
// This is the single source of truth for every color and font that varies by
// brand. Nothing here is referenced directly by components: the values are
// turned into CSS variables at boot (see theme/applyBrandCssVariables.js) and
// exposed to Tailwind as semantic utilities (see tailwind.config.js).
//
// To add a brand, copy this file, change the values, and register it in
// theme/brands/index.js. See theme/README.md.

const revivo = {
  name: "revivo",

  // Shown in "Powered By" footers on invoices/receipts/statements.
  productName: "Revivo",
  productEdition: "HOTEL-X",

  // ── Fonts ──────────────────────────────────────────────────────────────────
  // `stack` is what gets applied; `url` (optional) is loaded as a stylesheet
  // <link> at boot so the brand's webfont is available.
  fonts: {
    body: {
      family: "Outfit",
      stack: "'Outfit', Arial, sans-serif",
      url: "https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap",
    },
    heading: {
      family: "Outfit",
      stack: "'Outfit', Arial, sans-serif",
      url: "https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap",
    },
  },

  // ── Solid colors ───────────────────────────────────────────────────────────
  // Opacity-capable. Emitted as `R G B` triplets so Tailwind's `/opacity`
  // modifiers keep working (e.g. `bg-primary/50`). Keys are camelCase here and
  // become `--color-<kebab-case>` CSS variables.
  colors: {
    primary: "#007fff",
    primaryHover: "#1263d3",
    primaryDark: "#2a53e4",
    primaryLight: "#eaf2fd",
    accent: "#2f80ed",
    secondary: "#2f80ed",

    surface: "#ffffff",
    surfacePage: "#f8fafc",
    surfaceMuted: "#f4f4f4",

    border: "#d9d9d9",
    borderMuted: "#edf1f7",

    textPrimary: "#222b45",
    textSecondary: "#4d4d4d",
    textMuted: "#808080",
    textPlaceholder: "#8f9bb3",
    textInverse: "#ffffff",

    success: "#16a34a",
    warning: "#f9a63a",
    danger: "#f36960",
    info: "#2f80ed",

    // Light status tints — for badges/pills (status text on a soft tinted bg).
    successLight: "#e3f5ea",
    warningLight: "#fef0dc",
    dangerLight: "#fdeae8",

    // Neutral gray ramp — for raw grays without a semantic role. Brand-tunable.
    neutral50: "#fafafa",
    neutral100: "#f5f5f5",
    neutral200: "#e5e5e5",
    neutral300: "#d4d4d4",
    neutral400: "#b3b3b3",
    neutral500: "#808080",
    neutral600: "#545454",
    neutral700: "#404040",
    neutral800: "#333333",
    neutral900: "#1a1a1a",

    black: "#000000",
    white: "#ffffff",
  },

  // ── Overlays ───────────────────────────────────────────────────────────────
  // Colors whose alpha is intrinsic to the effect (hover veils, scrims). Emitted
  // verbatim as `--overlay-<kebab>`; used without opacity modifiers.
  overlays: {
    hover: "rgba(0, 0, 0, 0.15)", // was #00000026
    active: "rgba(0, 0, 0, 0.20)", // was #00000033
  },

  // ── Gradients ──────────────────────────────────────────────────────────────
  // Emitted as `--gradient-<kebab>`. Each brand owns its own gradient stops.
  gradients: {
    sidebar: "linear-gradient(180deg, #007fff 0%, #2a53e4 100%)",
    dynamicPricing: "linear-gradient(90deg, #f7be2b 0%, #f537f9 100%)",
  },
};

export default revivo;
